export enum CriarAtendimentoTypes {
  'LOAD_REQUEST' = '@criarAtendimento/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@criarAtendimento/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@criarAtendimento/LOAD_FAILURE',

  'FILTER_NOTAS' = '@criarAtendimento/FILTER_NOTAS',
  'CLEAN_NOTAS' = '@criarAtendimento/CLEAN_NOTAS',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface Filter {
  numNota: number;
  dtEmiIni: string;
  dtEmiFim: string;
  codParceiro?: number;
}

export interface FiltroNotas {
  numNota: number;
  dtEmiini: string;
  dtEmifim: string;
  codParc: number;
}

export interface Notas {
  nuNota: number;
  numNota: number;
  dtEmissao: string;
  remetente: string;
  origem: string;
  destinatario: string;
  destino: string;
  peso: number;
  valor: number;
}

export interface Protocolo {
  protocolo: number;
}
export interface CriarAtendimentoState {
  readonly notas: Notas[];
  readonly protocolo: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: Filter;
  readonly pagination: Pagination;
}
